import React, { Component, useContext } from "react";
import { Button, Col, Row, Typography, Card, List, Space, message, Popconfirm, Modal, Tooltip } from "antd";
import axios from 'axios'
import { MdOutlineEmail, MdOutlineMarkEmailRead } from "react-icons/md"
import { DeleteOutlined, EditOutlined, EyeOutlined, FilePdfOutlined, LinkOutlined } from "@ant-design/icons"


//compoenentes
import User from "../../../../Hooks/Logged";
import { renderMontoTransaccion } from "../../../Utils";
import CustomAvatar from "../../../Widgets/Avatar/Avatar";
import usePermissions from "../../../../Hooks/usePermissions";
import ModalTransaccion from "../../Finanzas/Transacciones/ModalTransaccion";
import ModalTransaccionDetalle from "../../Finanzas/Transacciones/ModalTransaccionDetalle";


const { Text } = Typography;
const moment = require('moment');

/**
 * @export
 * @class TransaccionesTab
 * @extends {Component}
 * @description Lista de transacciones del cliente
 */
class TransaccionesTab extends Component {

	constructor(props) {
		super(props)
		this.state = {
			transacciones: {
				data: [],
				limit: 20,
				page: 1,
				total: 0,
				pages: 0,
			},
			proveedor_id: this.props.proveedor_id,
			transaccion_id: undefined
		}
	}

	componentDidMount() {
		axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
		if(this.props.proveedor_id){
			this.getTransacciones()	
		} 
	}

	componentDidUpdate(prevProps){
		if(this.props.proveedor_id && prevProps.proveedor_id !== this.props.proveedor_id){
			this.getTransacciones()	
		} 
	}

	/**
	 * @memberof TransaccionesTab
	 * @method getTransacciones
	 * @description Obtiene los transacciones realcionadas al proveedor
	 *
	 */
	getTransacciones = ({
		page = this.state.transacciones.page,
		limit = this.state.transacciones.limit,
		proveedor_id = this.props.proveedor_id,
	} = this.state.transacciones) => {

		this.setState({ loading: true })
		axios.get('/transacciones', {
			params: {
				proveedor_id,
				page,
				limit
			}
		})
			.then(({ data }) => {
				this.setState({ 
					transacciones: {
						...data 
					} 
				});
			})
			.catch(error => {
				message.error('Error al traer los transacciones')
				console.log(error.response)
			}
			).finally(() => this.setState({ loading: false }))
	}

	/**
	 * @memberof TransaccionesTab
	 * @method desvincular
	 * @description Obtiene los transacciones del cliente
	 *
	 */
	desvincular = (transaccion_id) => {
		Modal.confirm({
			title: '¿Seguro de desvincular la transaccion?',
			okText: 'Si',
			cancelText: 'Cancelar',
			onOk: () => {
				return axios.put('/proveedor/desvincular', {
					transaccion_id
				}).then(response => {
					message.success('Transacción desvinculada')
					//this.getTransacciones()
				}).catch(error => {
					console.log("error", error);
					message.error(error.response.data.message ?? 'Error al desvincular')
				}).finally(e => this.props.updateAll())
			}
		})
	}


	render() {

		const { data } = this.state.transacciones

		return (
			<>
				<Row gutter={[8, 8]}>
					<List
						itemLayout="horizontal"
						dataSource={data}
						loading={this.state.loading}
						key={(item => item._id)}
						className="component-list width-100"
						pagination={{
							current: this.state.transacciones.page,
							pageSize: this.state.transacciones.limit,
							total: this.state.transacciones.total,
							position: 'bottom',
							className: "flex-left",
							showSizeChanger: true,
							onChange: (page, limit) => this.getTransacciones({ page, limit })
						}}
						renderItem={item => (
							<List.Item className="component-list-item transacciones">
								<Card className="ant-card-list width-100">
									<Row className="width-100" gutter={[16, 16]}>
										<Col xs={24} lg={2} className="center ">
											<Text className="text-date-format fecha">{moment(item.fecha).format('YYYY-MM-DD')}</Text>
										</Col>
										<Col xs={24} lg={4} className="center ">
											<Text className="concepto">{item.concepto}</Text>
										</Col>
										<Col xs={24} lg={4} className="center ">
											<Text className="concepto">{item.area_id?.nombre}</Text>
										</Col>
										<Col xs={24} lg={3} className="center ">
											<CustomAvatar
												image={axios.defaults.baseURL+"/upload/"+ item.cuenta_id?.logo}
												color={item.cuenta_id?.color}
												name={item.cuenta_id?.nombre}
											/>
											<Text ellipsis className="concepto">{item.cuenta_id?.nombre ?? ((item.tipo_pago == 2) ? "Especie" : null)}</Text>
										</Col>
										<Col xs={24} lg={3} className="center ">
											<CustomAvatar
												image={axios.defaults.baseURL+"/upload/"+ item.proyecto_id?.logo}
												color={item.proyecto_id?.color}
												name={item.proyecto_id?.nombre}
											/>
											<Text ellipsis className="concepto">{item.proyecto_id?.nombre}</Text>
										</Col>
										<Col xs={24} lg={4} className="center ">
											{renderMontoTransaccion({tipo: item.tipo, monto: item.monto})}
										</Col>
										<Col xs={24} lg={4} className="center">
											<Space direction="horizontal" size={5}>
												
												<Tooltip mouseEnterDelay={0} title="Ver el recibo de pago de esta transacción">
													<Button
														size="small"
														className="ant-btn-primary-gold"
														type="primary"
														//disabled={!this.props.verTransaccionesPropiedad}
														icon={<FilePdfOutlined style={{ color: "currentcolor" }} />}
														onClick={() => window.open(axios.defaults.baseURL + "/transaccion/recibo/" + item._id + "?Authorization=" + sessionStorage.getItem("token"))}
													/>
												</Tooltip>
												<Tooltip mouseEnterDelay={0} title="Ver la transacción">
													<Button
														size="small"
														className="ant-btn-primary-green"
														type="primary"
														//disabled={!this.props.verTransaccionesPropiedad}
														icon={<EyeOutlined style={{ color: "currentcolor" }} />}
														onClick={() => this.setState({modalDetalleVisible: true, transaccion_id: item._id, tipo_pago: item.tipo_pago})}
													/>
												</Tooltip>
												<Tooltip mouseEnterDelay={0} title="¿Desvincular la transacción del proveedor?">
													<Button
														size="small"
														className="ant-btn-primary-yellow"
														type="primary"
														disabled={!this.props.desvincularTransacciones}
														icon={<LinkOutlined style={{ color: "currentcolor" }} />}
														onClick={() => this.desvincular(item._id)}
													/>
												</Tooltip>
												<Tooltip mouseEnterDelay={0} title="Editar la transacción">
													<Button
														disabled={!this.props.editarTransacciones}
														size="small"
														type="primary"
														icon={<EditOutlined style={{ color: "currentcolor" }} />}
														onClick={() => this.setState({modalVisible: true, transaccion_id: item._id})}
													/>
												</Tooltip>
												<Popconfirm
													placement="topRight"
													title="¿Deseas eliminar esta transaccion?"
													onConfirm={() => axios.delete(`/transacciones`,
														{ params: { id: item._id } }).then(() => {
															this.getTransacciones()
															message.success('Transaccion eliminada')
														}).catch(error => console.log(error))
														.finally(e => this.props.updateAll())
													}
													okText="Si"
													cancelText="No"
												>
													<Button
														disabled={!this.props.eliminarTransacciones}
														size="small"
														type="primary"
														icon={<DeleteOutlined style={{ color: "currentcolor" }} />}
														title="Eliminar"
														danger
													/>
												</Popconfirm>
											</Space>
										</Col>
									</Row>
								</Card>
							</List.Item>
						)}
					/>
				</Row>

				{/*Modal solo para editar*/}
				<ModalTransaccion
					visible={this.state.modalVisible}
					onClose={() => {
						this.setState({modalVisible: false, transaccion_id: undefined})
						this.props.updateAll()
					}}
					transaccion_id={this.state.transaccion_id}
					proveedor_id={this.props.proveedor_id}
					disabled={{
						area: true,
						rubro: true,
						propiedad: true,
						cliente: true,
						factura: true,
						proyecto: true,
						tipo: true,
						inversion: true,
						acreedor: true,
						programada: true
					}}
					required={{
						tipo: false
					}}
				/>
				<ModalTransaccionDetalle
					visible={this.state.modalDetalleVisible}
					onClose={() => this.setState({modalDetalleVisible: false, transaccion_id: undefined})}
					transaccion_id={this.state.transaccion_id}
				/>
			</>
		)
	}
}

export default React.forwardRef((props, ref) => {

    const user = useContext(User);

    const permisos = usePermissions(user?.rol_id?.permisos, {
		desvincularTransacciones: ["proveedores", "transacciones", "unlink"],
        editarTransacciones: ["proveedores", "transacciones", "edit"],
        eliminarTransacciones: ["proveedores", "transacciones", "delete"]
    });

	return <TransaccionesTab ref={ref} {...props} user={user} {...permisos}/>
})